import { useContext } from 'react';

import { BrandContext } from 'context/BrandContext';
import { isStandardVariant } from 'helpers/iconSizes';
import { ICON_SIZES } from 'lib/constants/iconSizes';

const Chat = ({ className = '', svgSize = ICON_SIZES.MD }) => {
  const { theme } = useContext(BrandContext);
  const isStandardVariantIcon = isStandardVariant(svgSize);

  if (isStandardVariantIcon) {
    return (
      <svg
        width={svgSize}
        height={svgSize}
        className={className}
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M9.99976 11.3333H5.99967C4.52692 11.3333 3.33301 12.5273 3.33301 14V27.0572C3.33301 27.6511 4.0511 27.9486 4.47108 27.5286L7.33301 24.6667H19.333C20.8058 24.6667 21.9997 23.4728 21.9997 22V18H12.6664C11.1937 18 9.99976 16.8061 9.99976 15.3333V11.3333Z"
          fill={theme.icon.fill}
        />
        <path
          d="M26 3.99998C27.841 3.99998 29.334 5.49302 29.334 7.33397V20.3906C29.3337 21.5781 27.8975 22.1734 27.0576 21.334L24.3906 18.667H22.667V22C22.6668 23.8407 21.1747 25.3328 19.334 25.333H7.61035L4.94336 28C4.10338 28.8396 2.66699 28.2444 2.66699 27.0566V14C2.66718 12.1592 4.16014 10.666 6.00098 10.666H9.33398V7.33397C9.33398 5.49307 10.8261 4.00007 12.667 3.99998H26ZM6.00098 12C4.89652 12 4.00116 12.8956 4.00098 14V27.0566L6.8623 24.1953L6.96387 24.1113C7.07251 24.039 7.20153 24 7.33398 24H19.334C20.4383 23.9998 21.3338 23.1043 21.334 22V18.667H12.667C10.8263 18.6669 9.33433 17.1746 9.33398 15.334V12H6.00098ZM12.667 5.33397C11.5625 5.33406 10.667 6.22945 10.667 7.33397V15.334C10.6673 16.4382 11.5627 17.3339 12.667 17.334H24.667C24.7996 17.334 24.9284 17.3728 25.0371 17.4453L25.1387 17.5293L28 20.3906V7.33397C28 6.2294 27.1046 5.33397 26 5.33397H12.667ZM24.667 12.666C25.0349 12.6662 25.3338 12.9651 25.334 13.333C25.334 13.7011 25.035 13.9998 24.667 14H17.334C16.9658 14 16.667 13.7012 16.667 13.333C16.6672 12.965 16.9659 12.666 17.334 12.666H24.667ZM24.667 8.666C25.0351 8.666 25.3338 8.96496 25.334 9.33299C25.334 9.70118 25.0352 9.99998 24.667 9.99998H14.667C14.2989 9.9999 14 9.70113 14 9.33299C14.0002 8.96502 14.299 8.66609 14.667 8.666H24.667Z"
          fill={theme.icon.stroke}
        />
      </svg>
    );
  }

  return (
    <svg
      width={svgSize}
      height={svgSize}
      className={className}
      viewBox="0 0 56 56"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.917 26.833C16.917 29.4103 19.0067 31.5 21.584 31.5H39.084V38.5C39.084 41.0773 36.9943 43.1669 34.417 43.167H14.584L10.251 48.6807C9.56646 49.5519 8.16699 49.0679 8.16699 47.96V25.667C8.16699 23.0897 10.2567 21 12.834 21H16.917V26.833ZM40.251 24.208C40.7338 24.2084 41.1258 24.6002 41.126 25.083C41.126 25.566 40.7339 25.9576 40.251 25.958H30.334C29.8507 25.958 29.459 25.5663 29.459 25.083C29.4592 24.5999 29.8508 24.208 30.334 24.208H40.251ZM40.834 19.542C41.317 19.5422 41.709 19.9339 41.709 20.417C41.7088 20.9 41.3169 21.2918 40.834 21.292H23.917C23.4339 21.292 23.0422 20.9001 23.042 20.417C23.042 19.9337 23.4337 19.542 23.917 19.542H40.834ZM40.834 14.875C41.317 14.8752 41.709 15.2669 41.709 15.75C41.709 16.2331 41.317 16.6248 40.834 16.625H23.917C23.4337 16.625 23.042 16.2332 23.042 15.75C23.042 15.2668 23.4337 14.875 23.917 14.875H40.834Z"
        fill={theme.icon.fill}
      />
      <path
        d="M43.167 8.45834C46.2274 8.45856 48.709 10.9399 48.709 14.0003V36.2933C48.709 38.2321 46.2595 39.0794 45.0615 37.555L40.9922 32.3753H39.959V38.5003C39.9588 41.5607 37.4774 44.0423 34.417 44.0423H15.0088L10.9395 49.222C9.74156 50.7463 7.29227 49.8989 7.29199 47.9603V25.6673C7.29199 22.6068 9.77341 20.1253 12.834 20.1253H16.042V14.0003C16.042 10.9398 18.5234 8.45834 21.584 8.45834H43.167ZM12.834 21.8753C10.7399 21.8753 9.04199 23.5732 9.04199 25.6673V47.9603C9.04228 48.237 9.39237 48.3584 9.56348 48.141L13.8955 42.6263C14.0614 42.4152 14.3155 42.2923 14.584 42.2923H34.417C36.5109 42.2923 38.2088 40.5942 38.209 38.5003V32.3753H21.584C18.5234 32.3753 16.042 29.8939 16.042 26.8333V21.8753H12.834ZM21.584 10.2083C19.4899 10.2083 17.792 11.9063 17.792 14.0003V26.8333C17.792 28.9274 19.4899 30.6253 21.584 30.6253H41.417C41.6853 30.6255 41.9397 30.7483 42.1055 30.9593L46.4375 36.474C46.6087 36.6915 46.959 36.5702 46.959 36.2933V14.0003C46.959 11.9064 45.2609 10.2086 43.167 10.2083H21.584Z"
        fill={theme.icon.stroke}
      />
    </svg>
  );
};

Chat.propTypes = {
  className: PropTypes.string,
  svgSize: PropTypes.oneOf(Object.values(ICON_SIZES)),
};

export default Chat;
